import { Component, OnInit, Input, OnChanges, SimpleChanges, Output, EventEmitter } from '@angular/core';
import { Router } from '@angular/router';
import { ApiV2Service } from '../../../../services/api-v2.service';
import { SpinnerService } from '../../../../services/spinner.service';
import { CourseCard } from '../../../../interfaces/course-card.interface';
import { map } from 'rxjs/operators';
import { AuthService } from '../../../../services/auth.service';
import { MessagesModalService } from '../../../../services/messages-modal.service';
import { TranslateService } from '@ngx-translate/core';

@Component({
  selector: 'app-course-card',
  templateUrl: './course-card.component.html',
  styleUrls: ['./course-card.component.css']
})
export class CourseCardComponent implements OnInit, OnChanges {

  scaleCard: string;
  cardSizeScaled: number;
  profilesCount: number;
  @Input() cardSize: number;
  @Input() courseCardInfo: CourseCard;
  @Output('reload') deleteCourse: EventEmitter<any> = new EventEmitter();


  constructor(
    private translate:TranslateService,
    private api: ApiV2Service,
    private router: Router,
    private spinner: SpinnerService,
    private auth: AuthService,
    private message: MessagesModalService
  ) { }

  ngOnInit(): void {
    // this.scaleCard.subscribe(()=>{});
    //this.getProfilesByCourse();
  }

  ngOnChanges(changes: SimpleChanges) {
    this.scaleCard = `scale(${this.cardSize / 240})`;
    this.cardSizeScaled = this.cardSize / (this.cardSize / 240);
  }

  onEdit() {
    this.router.navigate(['courses/course-creator', this.courseCardInfo.id]);
  }

  onDeactivate() {
    alert('Desativando:' + this.courseCardInfo.id);
  }

  onDelete() {
    this.message.openDialog('warning', this.translate.instant('DIALOGMESSAGECOURSE.DELETETITLE'), this.translate.instant('DIALOGMESSAGECOURSE.DELETEMSG')).afterClosed()
      .subscribe((result: boolean) => {
        if (result) {
          this.spinner.showSpinner = true;
          this.api.deleteAlternativeService('DELETE_COURSE', this.courseCardInfo.id).subscribe(
            (data) => {
              this.deleteCourse.emit();
              this.spinner.showSpinner = false;
            },
            (error) => {
              console.log(error);
              this.spinner.showSpinner = false;
            }
          );
        }
      });
      this.spinner.showSpinner = false;
  }

  getProfilesByCourse() {
    this.spinner.showSpinner = true;
    this.api.getAlternativeService('GET_PROFILES_BY_COURSE', this.courseCardInfo.id).pipe(map((data) => {
      delete data['results'];
      delete data['next'];
      delete data['previous']
      return data['count'];
    })).subscribe(
      (studentsCount: number) => {
        this.profilesCount = studentsCount;
        this.spinner.showSpinner = false;
      },
      (error) => {
        console.log(error);
        this.spinner.showSpinner = false;
      }
    );
  }

  showActionButton() {
    return !(this.auth.currentMainOrganization.organizationType === 'Escuela' && !this.auth.currentUser.isOrgAdmin);
  }

  goToInfo() {
    this.router.navigate(['courses/course-info', this.courseCardInfo.id]);
  }
}
